import React from 'react';
import ToggleButton from 'react-toggle-button';
import { Colors } from '../../Tenants';
import './Toggle.scss';

interface ToggleProps {
  label: string;
  value: boolean;
  onToggle: (value: boolean) => void;
  description?: string;
}

const Toggle = ({ description, label, ...props }: ToggleProps) => (
  <div className="toggle">
    <div className="toggle__body">
      <div className="toggle__label">{label}</div>
      <ToggleButton
        colors={{
          activeThumb: {
            base: 'white',
          },
          inactiveThumb: {
            base: 'white',
          },
          active: {
            base: Colors.toggleActive,
            hover: Colors.toggleActive,
          },
          inactive: {
            base: '#919EAB',
            hover: '#919EAB',
          },
        }}
        inactiveLabel={null}
        activeLabel={null}
        thumbAnimateRange={[3, 21]}
        thumbStyle={{
          height: '18px',
          width: '18px',
          boxShadow: 'none',
        }}
        containerStyle={{
          width: '42px',
        }}
        trackStyle={{
          height: '24px',
          width: '42px',
        }}
        {...props}
      />
    </div>
    {description && <div className="toggle__description">{description}</div>}
  </div>
);

export default Toggle;
